import axios from 'axios';
import store from '../redux/store';
import { enqueueSnackbar } from 'notistack';
import { keycloak } from '../providers/KeycloakAuthProvider';
import { setUser } from '../redux/actions/actions';
import { config } from '../config';

const { keycloakUrl, keycloakAuthReam, publicUrl, keycloakClientId } = config;
const instance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    const user = store.getState().user;
    /*if (!user || !user.isEditorUser) {
      return config;
    }*/

    const isTokenReq = typeof config.data === 'string' && config.data.includes('grant_type');

    try {
      const isRefreshed = await keycloak.updateToken(5);
      const user = store.getState().user;
      if (user && isRefreshed) {
        store.dispatch(
          setUser({
            ...user,
            accessToken: keycloak.token,
            idToken: keycloak.idToken,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }

    if (keycloak.token && keycloak.token !== '' && !isTokenReq) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // removeToken();
    // console.log('ERROR FROM AXIOS:', error, error.response);
    if (error.response && error.response.status === 401) {
      keycloak.createLogoutUrl = () =>
        `${keycloakUrl}/realms/${keycloakAuthReam}/protocol/openid-connect/logout?id_token_hint=${
          keycloak.idToken
        }&post_logout_redirect_uri=${
          publicUrl + window.location.pathname + window.location.search
        }&client_id=${keycloakClientId}`;
      keycloak.logout();
      //store.dispatch(setRefetchTokens(null));
      store.dispatch(setUser(null));
    } else if (error.response && error.response.status === 500) {
      enqueueSnackbar(`Prišlo je do napake na zalednem delu, prosimo kontaktirajte tehnično podporo.`, {
        variant: 'error',
      });

      if (error.response.id) {
        enqueueSnackbar(`Koda napake: ${error.response.id}`, {
          variant: 'error',
        });
      }
    }

    // const customEvent = new CustomEvent('axios-error', { detail: error.response });
    // // console.log(error.response);
    // document.dispatchEvent(customEvent);

    return Promise.reject(error);
  }
);

export default instance;
